import React, { useRef, useEffect, memo } from 'react';
import SVGA from 'svgaplayerweb';

const SVGA_SRC = 'https://gd-file.gaodun.com/sub-tiku/svga/completed-knowledge.svga';
const SVGA_HD_SRC = 'https://gd-file.gaodun.com/sub-tiku/svga/completed-knowledge-HD.svga';

interface IProps {
    onFrameChange?: (frame: number) => void; // 帧数变化时的回调
    onAnimationFinished?: () => void; // 动画结束时的回调
}

const svgaContainerStyle: React.CSSProperties = {
    width: 570,
    height: 570,
    position: 'absolute',
    margin: 0,
};

const BadgeAnimation: React.FC<IProps> = ({ onFrameChange, onAnimationFinished }) => {
    const svgaContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const loadSVGA = async () => {
            const svgaContainer = svgaContainerRef.current;
            if (!svgaContainer) return;

            // 初始化播放器
            const player = new SVGA.Player(svgaContainer);
            const parser = new SVGA.Parser();

            // 加载 SVGA 文件
            parser.load(SVGA_HD_SRC, videoItem => {
                player.loops = 1;
                player.onFrame((frame: number) => {
                    if (onFrameChange) onFrameChange(frame);
                });
                player.onFinished(() => {
                    console.log('onFinished');
                    if (onAnimationFinished) onAnimationFinished();
                });
                player.setVideoItem(videoItem);
                player.startAnimation();
            });
        };

        loadSVGA();
    }, [onFrameChange, onAnimationFinished]);

    return <div ref={svgaContainerRef} style={svgaContainerStyle}></div>;
};

export default memo(BadgeAnimation);
